import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { routes } from './app.routes';
import { environment, environmentToken } from '@environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { enAU } from 'date-fns/locale';
import { provideHotToastConfig } from '@ngneat/hot-toast';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { httpInterceptor, httpsCsrfInterceptor } from '@app/shared/http-interceptors';
import { AbstractUnmappedNodesDataSource, UnmappedNodesDataSource } from '@app/shared/models/unmapped-nodes-datasource';
import { MappingService } from '@services/mapping.service';
import { SensorNodeService } from '@services/sensor-node.service';
import { ToastService } from '@services/toast/toast.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
      withComponentInputBinding()
    ),
    { provide: environmentToken, useValue: environment },
    {
      provide: MAT_DATE_LOCALE,
      useValue: enAU
    },
    provideDateFnsAdapter(),
    provideHotToastConfig(),
    provideHttpClient(withInterceptors([httpInterceptor, httpsCsrfInterceptor])),
    provideAnimations(),
    provideZonelessChangeDetection(),
    {
      provide: AbstractUnmappedNodesDataSource,
      useFactory: (mappingService: MappingService, sensorNodeService: SensorNodeService, toastService: ToastService) =>
        new UnmappedNodesDataSource(mappingService, sensorNodeService, toastService),
      deps: [MappingService]
    }
  ]
};
